import rotate from './rotatePoint'

const cursorConfig = (angle, i) => {
  const cursors = [
    'nwse-resize',
    'ns-resize',
    'nesw-resize',
    'ew-resize',
    'nwse-resize',
    'ns-resize',
    'nesw-resize',
    'ew-resize',
  ]

  const locations = [
    'topLeft',
    'top',
    'topRight',
    'right',
    'bottomRight',
    'bottom',
    'bottomLeft',
    'left',
  ]

  let j = i

  if (angle > 330) {
    // do nothing
  } else if (angle > 300) {
    j += 7
  } else if (angle > 250) {
    j += 6
  } else if (angle > 220) {
    j += 5
  } else if (angle > 170) {
    j += 4
  } else if (angle > 120) {
    j += 3
  } else if (angle > 73) {
    j += 2
  } else if (angle > 23) {
    j += 1
  }

  return {
    cursor: cursors[j % cursors.length],
    location: locations[i],
  }
}

const getHandles = ({ angle, w, h, r }) => {
  const handles = [
    {
      r,
      ...cursorConfig(angle, 0),
      ...rotate({ x: -w / 2 - 4, y: -h / 2 - 4 }, angle),
    },
    {
      r,
      ...cursorConfig(angle, 1),
      ...rotate({ x: 0, y: -h / 2 - 4 }, angle),
    },
    {
      r,
      ...cursorConfig(angle, 2),
      ...rotate({ x: w / 2 + 4, y: -h / 2 - 4 }, angle),
    },
    {
      r,
      ...cursorConfig(angle, 3),
      ...rotate({ x: w / 2 + 4, y: 0 }, angle),
    },
    {
      r,
      ...cursorConfig(angle, 4),
      ...rotate({ x: w / 2 + 4, y: h / 2 + 4 }, angle),
    },
    {
      r,
      ...cursorConfig(angle, 5),
      ...rotate({ x: 0, y: h / 2 + 4 }, angle),
    },
    {
      r,
      ...cursorConfig(angle, 6),
      ...rotate({ x: -w / 2 - 4, y: h / 2 + 4 }, angle),
    },
    {
      r,
      ...cursorConfig(angle, 7),
      ...rotate({ x: -w / 2 - 4, y: 0 }, angle),
    },
    {
      r,
      location: 'rotate',
      cursor: '-webkit-grab',
      ...rotate({ x: 0, y: -h / 2 - 25 }, angle),
    },
  ]

  return handles
}

const BlockHighlight = ({
  context,
  screen,
  bi,
  dx,
  dy,
  transform: t,
  imageScale,
  xScale,
  yScale,
  highlighted,
  selected,
  showResizeAndRotateHandles,
  updateResizeRotateHandles,
}) => {
  const lineWidth = 2
  const cx = dx * t.k + xScale(bi.map.x)
  const cy = dy * t.k + yScale(bi.map.y)
  const w = t.k * imageScale(bi.map.w)
  const h = t.k * imageScale(bi.map.h)
  const r = 4
  const dashed = !highlighted && showResizeAndRotateHandles && w > r * 2 * 3 && h > r * 2 * 3

  context.save()
  context.translate(cx, cy)
  context.setLineDash(dashed ? [4, 2] : [])
  context.strokeStyle = 'dodgerblue'
  context.lineWidth = lineWidth
  context.globalAlpha = selected ? 1 : 0.7

  const handles = getHandles({
    angle: bi.map.rotation,
    w,
    h,
    r,
  })

  context.beginPath()
  handles.forEach(
    ({ x, y }, i) =>
      i === 0 ? context.moveTo(x, y) : i < handles.length - 2 && context.lineTo(x, y) // ignore rotate handle
  )
  context.closePath()
  context.stroke()

  if (dashed && selected && showResizeAndRotateHandles) {
    context.setLineDash([])
    context.lineWidth = 1
    context.beginPath()
    context.moveTo(handles[1].x, handles[1].y)
    context.lineTo(handles[8].x, handles[8].y)
    context.stroke()

    context.setLineDash([])
    context.lineWidth = 2
    context.fillStyle = 'white'

    handles.forEach(({ x, y }) => {
      context.beginPath()
      context.arc(x, y, r, 0, Math.PI * 2)
      context.fill()
      context.stroke()
    })

    updateResizeRotateHandles(handles.map((h) => ({ ...h, r, cx: cx + h.x, cy: cy + h.y })))
  }

  context.restore()
}

export default BlockHighlight
